import { jobPosition } from '@/api/common/master-lists'

export default {
  namespaced: true,
  state () {
    return {
      loading: false,
      items: sessionStorage.getItem('jobPositions')
        ? JSON.parse(sessionStorage.getItem('jobPositions'))
        : []
    }
  },
  mutations: {
    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_ITEMS (state, items) {
      state.items = items
    },
    /**
     * Set the status.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_LOADING (state, loading) {
      state.loading = loading
    }
  },
  actions: {
    /**
     * Commit the SET_ITEMS mutation
     *
     */
    setItems ({ commit }, items) {
      commit('SET_ITEMS', items)

      sessionStorage.setItem('jobPositions', JSON.stringify(items))
    },

    /**
     * Fetch all JobPosition records.
     *
     * @param { commit, dispatch, state}
     */
    all ({ commit, dispatch, state }) {
      if (state.items.length) return

      commit('SET_LOADING', true)

      return jobPosition.index()
        .then(({ data }) => {
          commit('SET_ITEMS', data)

          sessionStorage.setItem('jobPositions', JSON.stringify(data))
        })
        .catch(({ response }) => {
          dispatch('httpException/handle', response, { root: true })
        })
        .finally(() => {
          commit('SET_LOADING', false)
        })
    }
  }
}
